import axios from 'axios'
import Cookies from 'js-cookie'

const state = {
  hospitalizedFighters: [],
  treatmentTimers: {}
}

const mutations = {
  SET_HOSPITALIZED_FIGHTERS(state, fighters) {
    state.hospitalizedFighters = fighters.map(fighter => {
      const endDate = new Date(fighter.endDate);
      const now = new Date();
      const remainingSeconds = Math.max(0, Math.floor((endDate - now) / 1000));
      
      return {
        ...fighter,
        remainingSeconds
      };
    });
  },
  UPDATE_TIMER(state, { fighterId, remainingSeconds }) {
    state.treatmentTimers[fighterId] = remainingSeconds;
  },
  CLEAR_TIMER(state, fighterId) {
    delete state.treatmentTimers[fighterId];
  }
}

const actions = {
  async hospitalizeFighter({ dispatch }, { fighterId, desiredHealth }) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_URL}/api/hospitals/hospitalize`,
        { fighterId, desiredHealth },
        {
          headers: { Authorization: `Bearer ${Cookies.get('jwt')}` }
        }
      )
      await dispatch('getHospitalizedFighters')
      await dispatch('player/loadPlayerData', null, { root: true })
      return response.data
    } catch (error) {
      throw new Error(error.response?.data?.error?.message || 'Failed to hospitalize fighter')
    }
  },

  async getHospitalizedFighters({ commit, dispatch }, playerId) {
    try {
      // Remove the checkTreatments call since backend now handles this
      const response = await axios.get(
        `${process.env.VUE_APP_API_URL}/api/hospitals/player/${playerId}`,
        {
          headers: { Authorization: `Bearer ${Cookies.get('jwt')}` }
        }
      );

      commit('SET_HOSPITALIZED_FIGHTERS', response.data);
      
      // Start countdown timers for each hospitalized fighter
      response.data.forEach(fighter => {
        dispatch('startCountdown', fighter);
      });

      return response.data;
    } catch (error) {
      console.error('Failed to get hospitalized fighters:', error);
      throw error;
    }
  },

  // Remove the checkTreatments method since it's no longer needed

  startCountdown({ commit, state, dispatch }, fighter) {
    const timerId = setInterval(() => {
      const currentSeconds = state.treatmentTimers[fighter.id] || fighter.remainingSeconds;
      
      if (currentSeconds <= 0) {
        clearInterval(timerId);
        commit('CLEAR_TIMER', fighter.id);
        // Refresh data when timer completes
        dispatch('getHospitalizedFighters');
        dispatch('player/loadPlayerData', null, { root: true });
      } else {
        commit('UPDATE_TIMER', { 
          fighterId: fighter.id, 
          remainingSeconds: currentSeconds - 1 
        });
      }
    }, 1000);

    // Store initial remaining seconds
    commit('UPDATE_TIMER', { 
      fighterId: fighter.id, 
      remainingSeconds: fighter.remainingSeconds 
    });
  }
}

const getters = {
  hospitalizedFighters: state => state.hospitalizedFighters,
  getRemainingTime: state => fighterId => state.treatmentTimers[fighterId] || 0,
  formatTime: () => seconds => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;
    
    const parts = [];
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0) parts.push(`${minutes}m`);
    if (remainingSeconds > 0 || parts.length === 0) parts.push(`${remainingSeconds}s`);
    
    return parts.join(' ');
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
